import { Wrench, Droplets, Wind, Sparkles, Truck, Hammer, Zap, Trees } from "lucide-react";

/**
 * "Built for..." social-proof strip.
 *
 * Modelled on the "customer logo row" pattern that dominates SaaS
 * marketing pages — but JobsBook doesn't yet have a public logo book, so
 * we use icon+name chips for the trades it targets. This still delivers
 * the "am I in the target audience?" moment above the fold that
 * research flagged as decisive for conversion.
 *
 * Palette: light section (contrast against dark hero) so the eye lands
 * here naturally on scroll.
 */
const TRADES = [
  { icon: Droplets,  label: "Pump hire" },
  { icon: Wrench,    label: "Plumbing" },
  { icon: Wind,      label: "HVAC" },
  { icon: Sparkles,  label: "Cleaning" },
  { icon: Truck,     label: "Mobile mechanics" },
  { icon: Hammer,    label: "Carpentry" },
  { icon: Zap,       label: "Electrical" },
  { icon: Trees,     label: "Landscaping" },
];

export default function TradesStrip() {
  return (
    <section
      className="bg-background border-y border-border py-10 md:py-14"
      data-testid="landing-trades-strip"
    >
      <div className="max-w-[1200px] mx-auto px-5 md:px-8">
        <div className="text-center mono text-[11px] uppercase tracking-[0.3em] text-muted-foreground mb-6">
          // Built for the trades that keep Ireland running
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
          {TRADES.map(({ icon: Icon, label }) => (
            <div
              key={label}
              className="flex flex-col items-center justify-center gap-2 py-4 px-2 rounded-lg border border-border bg-card hover:border-accent hover:-translate-y-[2px] transition-all"
              data-testid={`trade-chip-${label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <Icon className="h-5 w-5 text-muted-foreground group-hover:text-accent" />
              <span className="text-xs font-bold text-center leading-tight">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
